import { RootState } from "../../store";

export const getPurchaseHistory = (state: RootState) => state.purchaseHistory;
